import { withGeneratedLinks } from "../affiliateLinks";
import affiliateLinks from "../affiliateLinks.nl.json";
import { NL_PROVIDERS } from "../providers.nl";
import { VAT_RATE_NL, getNlEnergyTaxRate } from "../taxes.nl";
import type { CountryConfig } from "./types";

export const NL_CONFIG: CountryConfig = {
  country: "nl",
  domain: "epexprijzen.nl",
  siteTitle:
    "Live energieprijzen voor dynamische stroom in Nederland | EpexPrijzen.nl",
  siteTagline: "Actuele energieprijzen in Nederland",
  metaDescription:
    "Actuele energieprijzen in Nederland - Vergelijk energieprijzen en energiebedrijven",
  energyTaxLabel: "Energiebelasting",
  htmlLang: "nl",
  hreflang: "nl-NL",
  contactEmail: "info@epexprijzen.nl",
  vatRate: VAT_RATE_NL,
  feedInVatRate: VAT_RATE_NL,
  regions: null,
  defaultRegionId: null,
  getEnergyTaxRate: (date) => getNlEnergyTaxRate(date),
  expectedPriceSource: {
    name: "VvDE",
    fullName: "Vereniging van Dynamische Energieleveranciers",
    url: "https://vvde.nl/nieuws/verwachte-energieprijzen-inzichtelijk-via-de-vvde-api/",
    apiUrl: "https://dynamische-energieprijzen.nl/api/expected-prices?inclVat=0",
  },
  providers: withGeneratedLinks(NL_PROVIDERS, affiliateLinks),
  ctaUrl: "https://mijnbatterij.nl",
  ctaName: "Mijnbatterij",
  evccTemplate: "epexprijzen-nl",
  plausibleDomain: "epexprijzen.nl",
  alternateSite: {
    url: "https://epexprijzen.be",
    label: "België",
    flagEmoji: "🇧🇪",
    hreflang: "nl-BE",
  },
  extraHeadTags: [
    '<meta name="tradetracker-site-verification" content="25801dac67042dc06ce28eb8754c7b57ab9fbeb8" />',
  ],
};
